export const timeout = (ms: number): Promise<void> =>{
    return new Promise(resolve=>setTimeout(resolve, ms))
}

